import { Modal, Stack, Text, Group, Button, Loader } from "@mantine/core";

const ImpersonationSwitchModal = ({
  opened,
  isLoading,
  errorMessage,
  onClose,
  onRetry,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton={!isLoading}
      closeOnEscape={!isLoading}
      closeOnClickOutside={!isLoading}
      title="Switching back"
    >
      <Stack spacing="md">
        {isLoading ? (
          <Group align="center" spacing="sm">
            <Loader size="sm" />
            <Text size="sm">Switching back to your original profile…</Text>
          </Group>
        ) : errorMessage ? (
          <Stack spacing="xs">
            <Text size="sm" color="red">
              {errorMessage}
            </Text>
            <Text size="sm" color="dimmed">
              Please try again. If this persists, log out and log in.
            </Text>
            <Group position="right" spacing="sm">
              <Button variant="default" onClick={onClose}>
                Close
              </Button>
              <Button onClick={onRetry}>Try again</Button>
            </Group>
          </Stack>
        ) : (
          <Text size="sm" color="dimmed">
            Ready to switch back.
          </Text>
        )}
      </Stack>
    </Modal>
  );
};

export default ImpersonationSwitchModal;
